import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import JointCommitteeEditor from "../../editors/masterdata/jointCommittee";

const JointCommittees: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.JointCommitteesList}
			endpoint={Endpoint.JointCommittees}
			addScreen={{ screen: JointCommitteeEditor, isAllowed: hasPermission(Permission.JointCommitteesAdd) }}
			editScreen={{ screen: JointCommitteeEditor, isAllowed: hasPermission(Permission.JointCommitteesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.JointCommitteesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default JointCommittees;
